import { get, post } from '@/utils/apiBase.js'
const settlementAmountApi = (option) => {
    return post('/settlement/amount', option)
}
const settlementList = (option) => {
    return post('/settlement/list', option)
}
const modifyMailAmountSupplier = (option) => {
    return post('/settlement/order/modify_mail_amount/supplier', option)
}
const settlementInfoApi = (option) => {
    return post('/settlement/info', option)
}
const skuMailInfoListApi = (option) => {
    return post('/settlement/sku_mail_info/list', option)
}
const settlementOrderListApi = (option) => {
    return post('/settlement/order/list', option)
}
const settlementOrderRefundlistApi = (option) => {
    return post('/settlement/order/refundlist', option)
}
const settlementAuditingSupplierApi = (option) => {
    return post('/settlement/auditing/supplier', option)
}
// 供应商申请提现
const settlementWithdrawApplyApi = (option) => {
    return post('/settlement/withdraw/apply', option)
}
// 获取调整订单
const getSupplierAdjustmentList = option => {
    return get('/settlement/order/get_supplier_adjustment_list', option)
}
// 结算单调账明细下载
const downloadAdjustmentList = option => {
    return get('/settlement/order/supplier_adjustment_list/download', option)
}

export default {
    settlementAmountApi,
    settlementList,
    modifyMailAmountSupplier,
    settlementInfoApi,
    skuMailInfoListApi,
    settlementOrderListApi,
    settlementOrderRefundlistApi,
    settlementAuditingSupplierApi,
    settlementWithdrawApplyApi,
    getSupplierAdjustmentList,
    downloadAdjustmentList
};